import React from 'react';

import './main-title.css';

const MainTitle = ({...props}) => {
    return (
        <div className="main-title">
            <h1>{props.title}</h1>
        </div>
    );
}

export default MainTitle;



// WEBPACK FOOTER //
// ./src/components/page/main-title/MainTitle.js